
import { getRecoil } from 'recoil-nexus';
import moment from './moment';
import { authState } from '../recoil/auth';

const orderIdGen = (orderDttm: Date) => {
  let formatDttm = moment(orderDttm).format('YYYYMMDDHHmmss');
  let user_token_id = getRecoil(authState).user_token_id;
  let makeId = formatDttm + user_token_id;
  // OP = 포스 주문, OT = 테이블오더 주문, OK = 키오스크 주문
  let exOrderId = 'OT' + parseInt(makeId).toString(16).toUpperCase();
  return exOrderId;
};

const tranIdGen = (orderDttm: Date) => {
  let formatDttm = moment(orderDttm).format('YYYYMMDDHHmmss');
  let user_token_id = getRecoil(authState).user_token_id;
  let makeId = formatDttm + user_token_id;
  // TP = 포스 결제정보, TT = 테이블오더 결제정보, TK = 키오스크 결제정보
  let exTranId = 'TT' + parseInt(makeId).toString(16).toUpperCase();
  return exTranId;
};

const waitingIdGen = (orderDttm: Date) => {
  let formatDttm = moment(orderDttm).format('YYYYMMDDHHmmss');
  let user_token_id = getRecoil(authState).user_token_id;
  let makeId = formatDttm + user_token_id;
  // TP = 포스 결제정보, TT = 테이블오더 결제정보, TK = 키오스크 결제정보
  let exTranId = 'TT' + parseInt(makeId).toString(16).toUpperCase();
  return exTranId;
};

export { orderIdGen, tranIdGen, waitingIdGen };
